export default "__VITE_ASSET__ZKN0UaDv__"